import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "big-loader"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toolbelt = _resolveComponent("Toolbelt")!
  const _component_PanelContainer = _resolveComponent("PanelContainer")!
  const _component_imdex_spinner = _resolveComponent("imdex-spinner")!

  return (_openBlock(), _createElementBlock("div", {
    ref: "main",
    style: _normalizeStyle([{"flex":"1","width":"100%","display":"flex","height":"100%"}, `flex-direction:${_ctx.toolbeltPos == 'left' ? 'row' : 'row-reverse'}`])
  }, [
    _createVNode(_component_Toolbelt),
    _createElementVNode("div", {
      class: _normalizeClass(["bottom-drop-zone", { dragging: _ctx.isDragging }])
    }, null, 2),
    (_ctx.ready && _ctx.panelLayout != null && _ctx.api != null && _ctx.siteStore.activeSite != null)
      ? (_openBlock(), _createBlock(_component_PanelContainer, {
          key: 0,
          ref: "panelContainer",
          type: _ctx.panelLayout.type,
          children: _ctx.panelLayout.children || false,
          componentState: _ctx.panelLayout.componentState,
          id: '_viz'
        }, null, 8, ["type", "children", "componentState"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_imdex_spinner, {
            size: 2,
            width: 150
          })
        ]))
  ], 4))
}